export const buttonPositiveRoot = "button-positive"
export const buttonNegativeRoot = "button-negative"
export const buttonPositive = `&.${buttonPositiveRoot}`
export const buttonNegative = `&.${buttonNegativeRoot}`